module.exports = __webpack_public_path__ + "img/jujialei-2.0a8820b3.png";